<template>
  <settlement-entry-real
    v-if="show"
    @reset="reset"
    :k="k"
    :v="v"
    :t="t"
    :outgoingId="outgoingId"
  ></settlement-entry-real>
</template>

<script>
import SettlementEntryReal from "./SettlementEntryReal.vue";
export default {
  components: {
    SettlementEntryReal,
  },
  props: {
    k: {
      type: Array,
      require: false,
      default() {
        return null;
      },
    },
    v: {
      require: false,
      default() {
        return null;
      },
    },
    t:{
      require:false,
      default(){
        return 0
      }
    },
    outgoingId: {},
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    async reset() {
      this.show = false;
      await this.$nextTick();
      this.show = true;
    },
  },
};
</script>

<style>
</style>